import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { Select, Modal, Form, Input, Button, Table, Upload, message, Tabs, DatePicker } from "antd";
import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import {
  submitApplication,
  getAllApplications,
  getAllJobPostings,
  searchApplications,
  scheduleInterview,
  getAllInterviews,
  updateInterview,
  generateOfferLetter,
  downloadOfferLetter,
  sendOfferLetterEmail,
  getAllTemplates,
  createTemplate,
  updateTemplate,
  setActiveTemplate,
} from "../../service/recruitmentService";
import { getAllEmployeesMethod } from "../../service/ApiServices";

const Onboarding = () => {
  const [form] = Form.useForm();
  const [scheduleForm] = Form.useForm();
  const [updateForm] = Form.useForm();
  const [offerForm] = Form.useForm();
  const [templateForm] = Form.useForm();
  const [openApplyModal, setOpenApplyModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const [openInterviewDetailsModal, setOpenInterviewDetailsModal] = useState(false);
  const [openUpdateInterviewModal, setOpenUpdateInterviewModal] = useState(false);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [applications, setApplications] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [jobPostings, setJobPostings] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [interviewPagination, setInterviewPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const [jobTitle, setJobTitle] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [status, setStatus] = useState("");
  const [letterType, setLetterType] = useState("OfferLetter");
  const pageSizeOptions = [5, 10, 20, 50, 100];
  const branchOptions = [
    { value: "wattala", label: "Wattala" },
    { value: "negombo", label: "Negombo" },
    { value: "kaduwela", label: "Kaduwela" },
    { value: "kiribathgoda", label: "Kiribathgoda" },
  ];

  useEffect(() => {
    console.log("Fetching applications...",setSelectedApplication);
        console.log("Fetching applications...",applications);

    const fetchApplications = async () => {
      setLoading(true);
      const data = await getAllApplications();
      setLoading(false);
      if (Array.isArray(data)) {
        setApplications(data);
        setPagination((prev) => ({ ...prev, total: data.length }));
      } else {
        setApplications([]);
        setPagination((prev) => ({ ...prev, total: 0 }));
      }
    };
    fetchApplications();
  }, []);

  useEffect(() => {
    const fetchJobPostings = async () => {
      const data = await getAllJobPostings();
      if (Array.isArray(data)) {
        setJobPostings(data.filter((job) => job.status === "Open"));
      } else {
        setJobPostings([]);
      }
    };
    fetchJobPostings();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        await getAllEmployeesMethod({
          setEmployeeData: (responseData) => {
            const employeeArray = responseData.data || [];
            setEmployees(employeeArray);
          },
          setLoading: setLoading,
          params: { page: 1, limit: 1000 },
          search: "",
        });
      } catch (error) {
        console.error("Error fetching employees:", error);
        setEmployees([]);
        message.error("Failed to fetch employees");
      }
    };
    fetchEmployees();
  }, []);

 useEffect(() => {
  const fetchInterviews = async () => {
  setLoading(true);
  try {
    const data = await getAllInterviews();
    if (Array.isArray(data)) {
      setInterviews(data);
      setInterviewPagination((prev) => ({ ...prev, total: data.length }));
    } else {
      setInterviews([]);
      setInterviewPagination((prev) => ({ ...prev, total: 0 }));
      message.error("Failed to fetch interviews");
    }
  } catch (error) {
    message.error("Error fetching interviews: " + error.message);
  } finally {
    setLoading(false);
  }
};
  fetchInterviews();
}, []);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      try {
        const data = await getAllTemplates();
        if (Array.isArray(data)) {
          setTemplates(data);
        } else {
          setTemplates([]);
        }
      } catch (error) {
        message.error("Error fetching templates: " + error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  const fetchApplications = async () => {
    setLoading(true);
    const data = await getAllApplications();
    setLoading(false);
    if (Array.isArray(data)) {
      setApplications(data);
      setPagination((prev) => ({ ...prev, total: data.length }));
    } else {
      setApplications([]);
      setPagination((prev) => ({ ...prev, total: 0 }));
    }
  };

  const fetchInterviews = async () => {
    setLoading(true);
    try {
      const data = await getAllInterviews();
      if (Array.isArray(data)) {
        setInterviews(data);
        setInterviewPagination((prev) => ({ ...prev, total: data.length }));
      } else {
        setInterviews([]);
        setInterviewPagination((prev) => ({ ...prev, total: 0 }));
        message.error("Failed to fetch interviews");
      }
    } catch (error) {
      message.error("Error fetching interviews: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchApplications = async () => {
    setLoading(true);
    try {
      const data = await searchApplications({ jobTitle, candidateName, status });
      if (Array.isArray(data)) {
        setApplications(data);
        setPagination((prev) => ({ ...prev, total: data.length, current: 1 }));
      } else {
        setApplications([]);
        setPagination((prev) => ({ ...prev, total: 0, current: 1 }));
      }
    } catch (error) {
      message.error("Error searching applications: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInterviewTableChange = (pagination) => {
    setInterviewPagination(pagination);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

  const onApplyFinish = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("job_id", values.job_id);
      formData.append("candidate_name", values.candidate_name);
      formData.append("email", values.email);
      if (values.resume && values.resume.fileList && values.resume.fileList[0]) {
        formData.append("resume", values.resume.fileList[0].originFileObj);
      } else {
        message.error("Please upload a resume");
        setLoading(false);
        return;
      }
      const result = await submitApplication(formData);
      if (result) {
        message.success("Application submitted successfully");
        await fetchApplications();
        setOpenApplyModal(false);
        form.resetFields();
      } else {
        message.error("Failed to submit application");
      }
    } catch (error) {
      message.error("Error submitting application: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadResume = (resume) => {
    try {
      if (!resume.data || typeof resume.data !== 'string') {
        throw new Error('Base64 data is missing or invalid');
      }
      const byteCharacters = atob(resume.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: resume.contentType });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = resume.originalName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      message.error("Failed to download resume: " + error.message);
    }
  };

  const onScheduleInterviewFinish = async (values) => {
    setLoading(true);
    try {
      const interviewData = {
        application_id: selectedApplication._id,
        interviewer: values.interviewer,
        date: values.date.toISOString(),
      };
      const result = await scheduleInterview(interviewData);
      if (result) {
        message.success("Interview scheduled successfully");
        await fetchInterviews();
        setOpenScheduleModal(false);
        scheduleForm.resetFields();
      } else {
        message.error("Failed to schedule interview");
      }
    } catch (error) {
      message.error("Error scheduling interview: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const onUpdateInterviewFinish = async (values) => {
    setLoading(true);
    try {
      const interviewData = {
        feedback: values.feedback,
        status: values.status,
      };
      const result = await updateInterview(selectedInterview._id, interviewData);
      if (result) {
        message.success("Interview updated successfully");
        await fetchInterviews();
        setOpenUpdateInterviewModal(false);
        updateForm.resetFields();
      } else {
        message.error("Failed to update interview");
      }
    } catch (error) {
      message.error("Error updating interview: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateLetter = (interview, type) => {
    if (interview.status !== 'Completed') {
      message.error("Letter can only be generated for completed interviews");
      return;
    }
    setSelectedInterview(interview);
    setLetterType(type);
    setOpenOfferModal(true);
  };

  const onGenerateOfferLetterFinish = async (values) => {
  setLoading(true);
  try {
    const offerData = {
      application_id: selectedInterview.application_id._id,
      interview_id: selectedInterview._id,
      offer_details: values.offer_details,
      branch: values.branch,
      onBoard_date: values.onBoard_date.toISOString(),
      letter_type: letterType,
    };
    const result = await generateOfferLetter(offerData);
    if (result && result._id) {
      message.success(`${letterType} generated successfully`);
      setSelectedInterview({
        ...selectedInterview,
        offerLetter: result, 
      });
      await handleDownloadOfferLetter(result._id);
      await fetchInterviews();
      setOpenOfferModal(false);
      offerForm.resetFields();
    } else {
      message.error(`Failed to generate ${letterType}: No ID returned`);
    }
  } catch (error) {
    message.error(`Error generating ${letterType}: ` + error.message);
  } finally {
    setLoading(false);
  }
};

  const handleSendOfferLetterEmail = async (offerLetterId) => {
    if (!offerLetterId) {
      message.error("No letter ID provided");
      return;
    }
    setLoading(true);
    try {
      const result = await sendOfferLetterEmail(offerLetterId);
      if (result) {
        message.success("Letter email sent successfully");
        await fetchInterviews();
      } else {
        message.error("Failed to send letter email");
      }
    } catch (error) {
      message.error("Error sending letter email: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadOfferLetter = async (offerLetterId) => {
    if (!offerLetterId) {
      message.error("No letter ID provided");
      return;
    }
    setLoading(true);
    try {
      const blob = await downloadOfferLetter(offerLetterId);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${letterType.toLowerCase()}_${selectedInterview?.application_id?.candidate_name || 'candidate'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      message.success("Letter downloaded successfully");
    } catch (error) {
      message.error("Failed to download letter: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const onTemplateFinish = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('type', values.type);
      formData.append('companyDetails[name]', values.company_name);
      formData.append('companyDetails[address]', values.company_address);
      formData.append('companyDetails[phone]', values.company_phone);
      formData.append('companyDetails[email]', values.company_email);
      formData.append('companyDetails[website]', values.company_website);
      formData.append('content', values.content);
      if (values.logo && values.logo.fileList && values.logo.fileList[0]) {
        formData.append('logo', values.logo.fileList[0].originFileObj);
      }

      let result;
      if (selectedTemplate) {
        result = await updateTemplate(selectedTemplate._id, formData);
        message.success("Template updated successfully");
      } else {
        result = await createTemplate(formData);
        message.success("Template created successfully",result);
      }
      await fetchTemplates();
      setOpenTemplateModal(false);
      setSelectedTemplate(null);
      templateForm.resetFields();
    } catch (error) {
      message.error(`Error ${selectedTemplate ? 'updating' : 'creating'} template: ` + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSetActiveTemplate = async (templateId) => {
    setLoading(true);
    try {
      const result = await setActiveTemplate(templateId);
      if (result) {
        message.success("Template set as active successfully");
        await fetchTemplates();
      } else {
        message.error("Failed to set active template");
      }
    } catch (error) {
      message.error("Error setting active template: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const data = await getAllTemplates();
      if (Array.isArray(data)) {
        setTemplates(data);
      } else {
        setTemplates([]);
      }
    } catch (error) {
      message.error("Error fetching templates: " + error.message);
    } finally {
      setLoading(false);
    }
  };

 
const onBoardColumns = [
  {
    title: "Job Title",
    dataIndex: "application_id",
    key: "job_title",
    render: (application_id) => application_id?.job_id?.title || "N/A",
  },
  {
    title: "Candidate Name",
    dataIndex: "application_id",
    key: "candidate_name",
    render: (application_id) => application_id?.candidate_name || "N/A",
  },

  {
    title: "Feedback",
    dataIndex: "feedback",
    key: "feedback",
    render: (feedback) => feedback || "N/A",
  },
  {
    title: "Status",
    key: "offer_letter_status",
    render: (record) => {
      const hasOfferLetter = record.offerLetter && record.offerLetter.letter_type === 'OfferLetter';
      if (!hasOfferLetter) return <span style={{ color: '#6c757d' }}>N/A</span>;
      const status = record.offerLetter.status;
      const statusStyles = {
        Sent: { color: '#007bff', backgroundColor: '#e7f3ff', padding: '4px 8px', borderRadius: '4px' },
        Accepted: { color: '#28a745', backgroundColor: '#e6f4ea', padding: '4px 8px', borderRadius: '4px' },
        Rejected: { color: '#dc3545', backgroundColor: '#f8d7da', padding: '4px 8px', borderRadius: '4px' },
      };
      return (
        <span style={statusStyles[status] || { color: '#6c757d' }}>
          {status}
        </span>
      );
    },
  },
  {
    title: "Actions",
    key: "offer_letter_actions",
    render: (record) => {
      const hasOfferLetter = record.offerLetter && record.offerLetter.letter_type === 'OfferLetter';
      return (
        <td className="action-table-data">
          {!hasOfferLetter ? (
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => handleGenerateLetter(record, 'OfferLetter')}
              title="Generate offer letter"
            >
              <i data-feather="file-plus" className="feather-file-plus"></i>
            </Link>
          ) : (
            <>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleDownloadOfferLetter(record.offerLetter._id)}
                title="Download offer letter"
              >
                <i data-feather="download" className="feather-download"></i>
              </Link>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleSendOfferLetterEmail(record.offerLetter._id)}
                title="Send offer letter email"
              >
                <i data-feather="mail" className="feather-mail"></i>
              </Link>
            </>
          )}
        </td>
      );
    },
  },

];

const onBoardColumns1 = [
  {
    title: "Job Title",
    dataIndex: "application_id",
    key: "job_title",
    render: (application_id) => application_id?.job_id?.title || "N/A",
  },
  {
    title: "Candidate Name",
    dataIndex: "application_id",
    key: "candidate_name",
    render: (application_id) => application_id?.candidate_name || "N/A",
  },
  {
    title: "Feedback",
    dataIndex: "feedback",
    key: "feedback",
    render: (feedback) => feedback || "N/A",
  },
  {
    title: "Offer Letter Status",
    key: "offer_letter_status",
    render: (record) => {
      const hasOfferLetter = record.offerLetter && record.offerLetter.letter_type === 'OfferLetter';
      if (!hasOfferLetter) return <span style={{ color: '#6c757d' }}>N/A</span>;
      const status = record.offerLetter.status;
      const statusStyles = {
        Sent: { color: '#007bff', backgroundColor: '#e7f3ff', padding: '4px 8px', borderRadius: '4px' },
        Accepted: { color: '#28a745', backgroundColor: '#e6f4ea', padding: '4px 8px', borderRadius: '4px' },
        Rejected: { color: '#dc3545', backgroundColor: '#f8d7da', padding: '4px 8px', borderRadius: '4px' },
      };
      return (
        <span style={statusStyles[status] || { color: '#6c757d' }}>
          {status}
        </span>
      );
    },
  },
 
  {
    title: "Appointment Letter Status",
    key: "appointment_letter_status",
    render: (record) => {
      const hasAppointmentLetter = record.offerLetter && record.offerLetter.letter_type === 'AppointmentLetter';
      if (!hasAppointmentLetter) return <span style={{ color: '#6c757d' }}>N/A</span>;
      const status = record.offerLetter.status;
      const statusStyles = {
        Sent: { color: '#007bff', backgroundColor: '#e7f3ff', padding: '4px 8px', borderRadius: '4px' },
        Accepted: { color: '#28a745', backgroundColor: '#e6f4ea', padding: '4px 8px', borderRadius: '4px' },
        Rejected: { color: '#dc3545', backgroundColor: '#f8d7da', padding: '4px 8px', borderRadius: '4px' },
      };
      return (
        <span style={statusStyles[status] || { color: '#6c757d' }}>
          {status}
        </span>
      );
    },
  },
  {
    title: "Actions",
    key: "appointment_letter_actions",
    render: (record) => {
      const hasAppointmentLetter = record.offerLetter && record.offerLetter.letter_type === 'AppointmentLetter';
      return (
        <td className="action-table-data">
          {!hasAppointmentLetter ? (
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => handleGenerateLetter(record, 'AppointmentLetter')}
              title="Generate appointment letter"
            >
              <i data-feather="file-plus" className="feather-file-plus"></i>
            </Link>
          ) : (
            <>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleDownloadOfferLetter(record.offerLetter._id)}
                title="Download appointment letter"
              >
                <i data-feather="download" className="feather-download"></i>
              </Link>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleSendOfferLetterEmail(record.offerLetter._id)}
                title="Send appointment letter email"
              >
                <i data-feather="mail" className="feather-mail"></i>
              </Link>
            </>
          )}
        </td>
      );
    },
  },
];

  const templateColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Active",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (isActive ? "Yes" : "No"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <td className="action-table-data">
          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => {
              setSelectedTemplate(record);
              templateForm.setFieldsValue({
                name: record.name,
                type: record.type,
                company_name: record.companyDetails.name,
                company_address: record.companyDetails.address,
                company_phone: record.companyDetails.phone,
                company_email: record.companyDetails.email,
                company_website: record.companyDetails.website,
                content: record.content,
              });
              setOpenTemplateModal(true);
            }}
            title="Edit template"
          >
            <i data-feather="edit" className="feather-edit"></i>
          </Link>
          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => handleSetActiveTemplate(record._id)}
            title="Set as active"
          >
            <i data-feather="check-circle" className="feather-check-circle"></i>
          </Link>
        </td>
      ),
    },
  ];

  const renderJobOption = (job) => (
    <div>
      <div><strong>{job.title}</strong></div>
      <div>Requirements: {job.requirements?.length ? job.requirements.join(", ") : "N/A"}</div>
      <div>Due Date: {job.dueDate ? moment(job.dueDate).format("YYYY-MM-DD") : "N/A"}</div>
    </div>
  );

  return (
    <div className="page-wrapper-lt">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Onboarding</h4>
                <h6>Manage employee onboarding</h6>
              </div>
            </div>
            <div className="page-btn">
              <a
                className="btn btn-added"
                onClick={() => {
                  setSelectedTemplate(null);
                  templateForm.resetFields();
                  setOpenTemplateModal(true);
                }}
                title="Create new template"
              >
                <PlusCircle className="me-2" />
                Template
              </a>
            </div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div
              className="container mt-3"
              style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-3 text-start">
                  <label className="form-label">Job Title</label>
                  <Input
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                    placeholder="Enter job title"
                    style={{ width: "80%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Candidate Name</label>
                  <Input
                    value={candidateName}
                    onChange={(e) => setCandidateName(e.target.value)}
                    placeholder="Enter candidate name"
                    style={{ width: "80%", height: "40px" }}
                  />
                </div>
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Status</label>
                  <Select
                    value={status}
                    onChange={(value) => setStatus(value)}
                    placeholder="Select status"
                    allowClear
                    style={{ width: "80%", height: "40px" }}
                  >
                    {["Pending", "Reviewed", "Rejected", "Accepted"].map((s) => (
                      <Select.Option key={s} value={s}>
                        {s}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            <div
              className="container mt-0"
              style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}
            >
              <div className="row d-flex align-items-center justify-content-start">
                <div className="col-12 col-md-2 mb-3 text-start">
                  <Button
                    disabled={loading}
                    className="btn btn-submit"
                    onClick={handleSearchApplications}
                    style={{ height: "38px", width: "55%" }}
                  >
                    {loading ? "Searching..." : "Search"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body">
            <div className="table-top"></div>
            <Tabs defaultActiveKey="3">
              <Tabs.TabPane tab="Offer Letters" key="3">
                <div className="table-responsive">
                  <Table
                    loading={loading}
                    columns={onBoardColumns}
  dataSource={interviews.filter(
            (interview) =>
            
              interview.status === "Completed"
          )}                    rowKey="_id"
                    pagination={{
                      current: interviewPagination.current,
                      pageSize: interviewPagination.pageSize,
                      pageSizeOptions: ["5", "10", "20", "50"],
                      total: interviewPagination.total,
                      showSizeChanger: true,
                      showQuickJumper: true,
                      showTotal: (total) => `Total ${total} items`,
                    }}
                    onChange={handleInterviewTableChange}
                  />
                </div>
              </Tabs.TabPane>
               <Tabs.TabPane tab="Appointment Letters" key="5">
      <div className="table-responsive">
        <Table
          loading={loading}
          columns={onBoardColumns1}
          dataSource={interviews.filter(
            (interview) =>
              interview.offerLetter &&
              interview.offerLetter.letter_type === "OfferLetter" &&
              interview.offerLetter.status === "Accepted"
          )}
          rowKey="_id"
          pagination={{
            current: interviewPagination.current,
            pageSize: interviewPagination.pageSize,
            pageSizeOptions: ["5", "10", "20", "50"],
            total: interviews.filter(
              (interview) =>
                interview.offerLetter &&
                interview.offerLetter.letter_type === "OfferLetter" &&
                interview.offerLetter.status === "Accepted"
            ).length,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `Total ${total} items`,
          }}
          onChange={handleInterviewTableChange}
        />
      </div>
    </Tabs.TabPane>
              <Tabs.TabPane tab="Templates" key="4">
                <div className="table-responsive">
                  <Table
                    loading={loading}
                    columns={templateColumns}
                    dataSource={templates}
                    rowKey="_id"
                    pagination={{ pageSize: 5 }}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        title="Apply for Job"
        open={openApplyModal}
        onCancel={() => {
          setOpenApplyModal(false);
          form.resetFields();
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        <Form form={form} onFinish={onApplyFinish} layout="vertical">
          <Form.Item
            name="job_id"
            label="Job Posting"
            rules={[{ required: true, message: "Please select a job" }]}
          >
            <Select
              placeholder="Select a job"
              showSearch
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            >
              {jobPostings.map((job) => (
                <Select.Option key={job._id} value={job._id} label={job.title}>
                  {renderJobOption(job)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="candidate_name"
            label="Candidate Name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>
          <Form.Item
            name="resume"
            label="Resume"
            valuePropName="file"
            rules={[{ required: true, message: "Please upload your resume" }]}
          >
            <Upload
              accept=".pdf"
              maxCount={1}
              beforeUpload={() => false}
            >
              <Button>Upload Resume (PDF only)</Button>
            </Upload>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit Application
            </Button>
            <Button
              onClick={() => {
                setOpenApplyModal(false);
                form.resetFields();
              }}
              style={{ marginLeft: 8 }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        zIndex={200000}
        title="Application Details"
        open={openDetailsModal}
        onCancel={() => setOpenDetailsModal(false)}
        footer={[
          <Button key="close" className="btn btn-cancel" onClick={() => setOpenDetailsModal(false)}>
            Close
          </Button>,
        ]}
      >
        {selectedApplication && (
          <div>
            <p><strong>Job Title:</strong> {selectedApplication.job_id?.title || "N/A"}</p>
            <p><strong>Candidate Name:</strong> {selectedApplication.candidate_name}</p>
            <p><strong>Email:</strong> {selectedApplication.email}</p>
            <p><strong>Status:</strong> {selectedApplication.status}</p>
            <p><strong>Applied Date:</strong> {selectedApplication.applied_at ? moment(selectedApplication.applied_at).format("YYYY-MM-DD") : "N/A"}</p>
            <p><strong>Resume:</strong> {selectedApplication.resume?.originalName || "N/A"}</p>
            {selectedApplication.resume?.contentType === "application/pdf" && (
              <Button
                className="btn btn-submit"
                onClick={() => handleDownloadResume(selectedApplication.resume)}
              >
                Download Resume
              </Button>
            )}
          </div>
        )}
      </Modal>

      <Modal
        zIndex={200000}
        title="Schedule Interview"
        open={openScheduleModal}
        onCancel={() => {
          setOpenScheduleModal(false);
          scheduleForm.resetFields();
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        <Form form={scheduleForm} onFinish={onScheduleInterviewFinish} layout="vertical">
          <Form.Item
            name="application_id"
            label="Application"
            initialValue={selectedApplication?.candidate_name}
          >
            <Input disabled value={selectedApplication?.candidate_name} />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            initialValue={selectedApplication?.email}
          >
            <Input disabled value={selectedApplication?.email} />
          </Form.Item>
          <Form.Item
            name="interviewer"
            label="Inter{BuInterviewer"
            rules={[{ required: true, message: "Please select an interviewer" }]}
          >
            <Select placeholder="Select an interviewer">
              {employees.map((employee) => (
                <Select.Option key={employee._id} value={employee._id}>
                  {employee.full_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="date"
            label="Interview Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker showTime format="YYYY-MM-DD HH:mm" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Schedule Interview
            </Button>
            <Button
              onClick={() => {
                setOpenScheduleModal(false);
                scheduleForm.resetFields();
              }}
              style={{ marginLeft: 8 }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        zIndex={200000}
        title="Interview Details"
        open={openInterviewDetailsModal}
        onCancel={() => setOpenInterviewDetailsModal(false)}
        footer={[
          <Button key="close" className="btn btn-cancel" onClick={() => setOpenInterviewDetailsModal(false)}>
            Close
          </Button>,
        ]}
      >
        {selectedInterview && (
          <div>
            <p><strong>Job Title:</strong> {selectedInterview.application_id?.job_id?.title || "N/A"}</p>
            <p><strong>Candidate Name:</strong> {selectedInterview.application_id?.candidate_name || "N/A"}</p>
            <p><strong>Interviewer:</strong> {selectedInterview.interviewer?.full_name || "N/A"}</p>
            <p><strong>Date:</strong> {selectedInterview.date ? moment(selectedInterview.date).format("YYYY-MM-DD HH:mm") : "N/A"}</p>
            <p><strong>Status:</strong> {selectedInterview.status || "N/A"}</p>
            <p><strong>Feedback:</strong> {selectedInterview.feedback || "N/A"}</p>
            {selectedInterview.offerLetter && (
              <p>
                <strong>{selectedInterview.offerLetter.letter_type}:</strong>{" "}
                <Button
                  className="btn btn-submit"
                  onClick={() => handleDownloadOfferLetter(selectedInterview.offerLetter._id)}
                >
                  Download
                </Button>
              </p>
            )}
          </div>
        )}
      </Modal>

      <Modal
        zIndex={200000}
        title="Update Interview"
        open={openUpdateInterviewModal}
        onCancel={() => {
          setOpenUpdateInterviewModal(false);
          updateForm.resetFields();
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        <Form form={updateForm} onFinish={onUpdateInterviewFinish} layout="vertical">
          <Form.Item
            name="feedback"
            label="Feedback"
          >
            <Input.TextArea placeholder="Enter feedback" />
          </Form.Item>
          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true, message: "Please select a status" }]}
          >
            <Select placeholder="Select status">
              {["Scheduled", "Completed", "Cancelled"].map((s) => (
                <Select.Option key={s} value={s}>
                  {s}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update Interview
            </Button>
            <Button
              onClick={() => {
                setOpenUpdateInterviewModal(false);
                updateForm.resetFields();
              }}
              style={{ marginLeft: 8 }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>

  <Modal
  zIndex={200000}
  title={`Generate ${letterType}`}
  open={openOfferModal}
  onCancel={() => {
    setOpenOfferModal(false);
    offerForm.resetFields();
  }}
  footer={null}
  maskClosable={false}
  closable={true}
>
  <Form form={offerForm} onFinish={onGenerateOfferLetterFinish} layout="vertical">
    <Form.Item
      name="candidate_name"
      label="Candidate Name"
      initialValue={selectedInterview?.application_id?.candidate_name}
    >
      <Input disabled />
    </Form.Item>
    <Form.Item
      name="job_title"
      label="Job Title"
      initialValue={selectedInterview?.application_id?.job_id?.title}
    >
      <Input disabled />
    </Form.Item>
    <Form.Item
      name="branch"
      label="Branch"
      rules={[{ required: true, message: "Please select(branch) a branch" }]}
    >
      <Select placeholder="Select branch">
        {branchOptions.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item
      name="onBoard_date"
      label="Onboarding Date"
      rules={[{ required: true, message: "Please select an onboarding date" }]}
    >
      <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
    </Form.Item>
    <Form.Item
      name="offer_details"
      label="Offer Details"
      rules={[{ required: true, message: "Please enter offer details" }]}
    >
      <Input.TextArea
        placeholder="Enter compensation, benefits, and other details"
        rows={4}
      />
    </Form.Item>
    <Form.Item>
      <Button type="primary" htmlType="submit" loading={loading}>
        Generate {letterType}
      </Button>
      {selectedInterview?.offerLetter?._id && selectedInterview?.offerLetter?.status !== 'Sent' && (
        <Button
          type="default"
          onClick={() => handleSendOfferLetterEmail(selectedInterview.offerLetter._id)}
          loading={loading}
          style={{ marginLeft: 8 }}
        >
        </Button>
      )}
      <Button
        onClick={() => {
          setOpenOfferModal(false);
          offerForm.resetFields();
        }}
        style={{ marginLeft: 8 }}
      >
        Cancel
      </Button>
    </Form.Item>
  </Form>
</Modal>
      <Modal
        zIndex={200000}
        title={selectedTemplate ? "Edit Template" : "Create Template"}
        open={openTemplateModal}
        onCancel={() => {
          setOpenTemplateModal(false);
          templateForm.resetFields();
          setSelectedTemplate(null);
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        <Form form={templateForm} onFinish={onTemplateFinish} layout="vertical">
          <Form.Item
            name="name"
            label="Template Name"
            rules={[{ required: true, message: "Please enter a template name" }]}
          >
            <Input placeholder="Enter template name" />
          </Form.Item>
          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: "Please select a type" }]}
          >
            <Select placeholder="Select type">
              <Select.Option value="OfferLetter">Offer Letter</Select.Option>
              <Select.Option value="AppointmentLetter">Appointment Letter</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="company_name"
            label="Company Name"
            rules={[{ required: true, message: "Please enter company name" }]}
          >
            <Input placeholder="Enter company name" />
          </Form.Item>
          <Form.Item
            name="company_address"
            label="Company Address"
            rules={[{ required: true, message: "Please enter company address" }]}
          >
            <Input placeholder="Enter company address" />
          </Form.Item>
          <Form.Item
            name="company_phone"
            label="Company Phone"
            rules={[{ required: true, message: "Please enter company phone" }]}
          >
            <Input placeholder="Enter company phone" />
          </Form.Item>
          <Form.Item
            name="company_email"
            label="Company Email"
            rules={[{ required: true, message: "Please enter company email" }]}
          >
            <Input placeholder="Enter company email" />
          </Form.Item>
          <Form.Item
            name="company_website"
            label="Company Website"
          >
            <Input placeholder="Enter company website" />
          </Form.Item>
          <Form.Item
            name="logo"
            label="Company Logo"
            valuePropName="file"
          >
            <Upload
              accept="image/*"
              maxCount={1}
              beforeUpload={() => false}
            >
              <Button>Upload Logo</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            name="content"
            label="Template Content"
            rules={[{ required: true, message: "Please enter template content" }]}
          >
            <Input.TextArea
              placeholder="Use placeholders like {candidate_name}, {job_title}, etc."
              rows={6}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {selectedTemplate ? "Update Template" : "Create Template"}
            </Button>
            <Button
              onClick={() => {
                setOpenTemplateModal(false);
                templateForm.resetFields();
                setSelectedTemplate(null);
              }}
              style={{ marginLeft: 8 }}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </Button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default Onboarding;